module.exports = __webpack_public_path__ + "img/radio_mic.9e43e1e3.jpg";